import { find } from 'lodash-es';

import { MapPopupContent, MapPopupTitle } from 'src/common/components/googleMap/Styles';
import LabeledDataView from 'src/core/components/LabeledDataView';
import { Grid, GridColumn } from 'src/core/components/styled';
import { useSelector } from 'src/core/hooks/useSelector';
import translate from 'src/core/services/translate';
import { AppState } from 'src/store';
import { MarkerItem } from './MapComponent';

type Props = {
  selectedCluster?: MarkerItem[];
  setSelectedMarker: (marker: MarkerItem) => void;
};

const RubiconServicesClusterTooltip = ({ selectedCluster, setSelectedMarker }: Props) => {
  const rubiconServicesForMapLocation = useSelector(
    (state: AppState) => state.customers.rubiconServices.rubiconServices,
  );
  const rubiconServicesForMapLocationFiltered = selectedCluster ? rubiconServicesForMapLocation.filter(s => {
    return s.custId && s.siteID && selectedCluster.some(c => c.id === `${s.custId}:${s.siteID}`);
  }) : [];

  const locationName = rubiconServicesForMapLocationFiltered.length > 0 ? `${rubiconServicesForMapLocationFiltered[0].siteName} ${rubiconServicesForMapLocationFiltered[0].siteID}` : '';
  const locationAddress = rubiconServicesForMapLocationFiltered.length > 0 ? `${rubiconServicesForMapLocationFiltered[0].siteAddress}, ${rubiconServicesForMapLocationFiltered[0].siteCity}, ${rubiconServicesForMapLocationFiltered[0].siteState}` : '';

  return (
    <>
      <MapPopupTitle title={`${locationName} Services`} secondTitle={locationAddress}/>
      <MapPopupContent>
        <Grid multiLine padding="small no">
          {rubiconServicesForMapLocationFiltered.map((c, index) => (
            <GridColumn key={index} size="12/12" margin="xxSmall no">
              <div 
                onClick={() => {
                  const clusterService = find(selectedCluster, { id: `${c.custId}:${c.siteID}` });
                  if (clusterService) {
                    setSelectedMarker({
                      ...clusterService,
                      secondaryId: c.svcID,
                      position: clusterService.position,
                    });
                  }
                }}
                style={{ cursor: 'pointer' }}
                >
                  <LabeledDataView
                    noWrap
                    width="calc(100% - 10px)"
                    size="small"
                    label={translate('containers.container')}
                    value={`${c.equipmentName} - ${c.svcID}`}
                  />
              </div>
            </GridColumn>
          ))}
        </Grid>
      </MapPopupContent>
    </>
  );
}

export default RubiconServicesClusterTooltip;
